import { useFrame, useThree } from "@react-three/fiber";
import { EffectComposer, Bloom, N8AO, SMAA, ToneMapping } from "@react-three/postprocessing";

import {
  EffectComposer as ImpEffectComposer,
  RenderPass,
  BloomEffect,
  EffectPass,
  ToneMappingEffect,
  BlendFunction,
} from "postprocessing";
import { N8AOPostPass } from "n8ao";

import { ToneMappingMode } from "postprocessing";
import { useEffect, useMemo, useRef } from "react";

import * as THREE from "three";

const PostEffects = ({ performanceMode = false }) => {
  const n8PassRef = useRef();

  useEffect(() => {
    console.log(n8PassRef.current);
    if (n8PassRef.current) n8PassRef.current.configuration.transparencyAware = false;
  }, [n8PassRef.current]);

  const { scene, camera, gl, size } = useThree();

  useEffect(() => {
    gl.toneMapping = THREE.NoToneMapping;
  }, []);

  const composer = useMemo(() => {
    const composer = new ImpEffectComposer(gl, {
      frameBufferType: THREE.HalfFloatType,
    });

    composer.multisampling = performanceMode ? 0 : 2;
    composer.addPass(new RenderPass(scene, camera));
    const n8aopass = new N8AOPostPass(scene, camera);
    n8aopass.configuration.transparencyAware = true;

    n8aopass.configuration.aoRadius = 125;
    n8aopass.configuration.intensity = 1.5;
    n8aopass.configuration.screenSpaceRadius = true;
    n8aopass.setQualityMode("Medium");

    if (!performanceMode) {
      composer.addPass(n8aopass);
    }

    let bloomEffect = new BloomEffect(BlendFunction.ADD);
    bloomEffect.luminanceThreshold = 0.9;
    bloomEffect.intensity = 0.15;

    composer.addPass(new EffectPass(camera, bloomEffect));

    let toneMappingEffect = new ToneMappingEffect();
    toneMappingEffect.mode = ToneMappingMode.ACES_FILMIC;
    composer.addPass(new EffectPass(camera, toneMappingEffect));

    return composer;
  }, [performanceMode]);

  useEffect(() => composer?.setSize(size.width, size.height), [composer, size]);

  useFrame((delta) => {
    composer.render(delta);
  }, 3);

  return null;

  if (performanceMode)
    return (
      <EffectComposer disableNormalPass multisampling={0} renderPriority={3}>
        <Bloom
          luminanceThreshold={0.9}
          // luminanceSmoothing={0.1}
          intensity={0.15}
        />

        <ToneMapping mode={ToneMappingMode.ACES_FILMIC} />
      </EffectComposer>
    );
  else {
    return (
      <EffectComposer disableNormalPass multisampling={2} renderPriority={3}>
        <Bloom
          luminanceThreshold={0.9}
          // luminanceSmoothing={0.1}
          intensity={0.15}
        />

        <N8AO color="black" aoRadius={125} intensity={1.5} screenSpaceRadius quality="medium" ref={n8PassRef} transparencyAware />

        <ToneMapping mode={ToneMappingMode.ACES_FILMIC} />
      </EffectComposer>
    );
  }
};

export default PostEffects;
